import { createAction } from 'redux-actions';

export const changeThemeToDark = createAction('CHANGE_THEME_TO_DARK');
export const changeThemeToLight = createAction('CHANGE_THEME_TO_LIGHT');
export const setPriceHistoryRange = createAction('SET_PRICE_HISTORY_RANGE');
export const setRatingHistoryRange = createAction('SET_RATING_HISTORY_RANGE');
